import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, fontFamilies, palette, fontWeights, spaceMin, siteMediumWidth, siteMaxWidth }: Theme) => ({
  root: {
    width: '100%',
    maxWidth: siteMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    position: 'relative',
    height: '36.25rem',
    margin: '0 auto 2rem',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPositionY: 'bottom',
    backgroundPositionX: 'center',
    [breakpoints.between(455, 767)]: {
      height: '43rem',
    },
    [breakpoints.up('md')]: {
      height: 'unset',
      marginBottom: '3rem',
      backgroundPositionX: 'right',
      backgroundPositionY: 'center',
    },
  },
  inner: {
    position: 'relative',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'stretch',
    [breakpoints.up('xl')]: {
      maxWidth: siteMediumWidth,
      margin: '0 auto',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flexGrow: 1,
    gap: '1.5rem',
    height: '100%',
    padding: `2rem ${spaceMin}`,
    [breakpoints.up('md')]: {
      width: `calc((100% - ${spaceMin}) / 2)`,
      minWidth: '21.75rem',
      position: 'relative',
      flexGrow: 'unset',
      padding: `3rem 0 3rem ${spaceMin}`,
    },
    [breakpoints.up('xl')]: {
      padding: '3rem 0',
    },
  },
  title: {
    maxWidth: '18.75rem',
    margin: 0,
    color: palette.common.white,
    fontFamily: fontFamilies.primary,
    fontSize: '1.75rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.4,
    [breakpoints.up('md')]: {
      maxWidth: '22rem',
      fontSize: '1.75rem',
    },
    [breakpoints.up('xl')]: {
      fontSize: '2.25rem',
      maxWidth: '34.375rem',
      lineHeight: 1.33,
    },
    '& sup': {
      position: 'relative',
      lineHeight: 0,
    },
  },
  newLine: {
    [breakpoints.between('md', 'xl')]: {
      display: 'block',
    },
  },
  text: {
    maxWidth: '21rem',
    margin: 0,
    color: palette.common.white,
    fontWeight: fontWeights.regular,
    fontSize: '1.3rem',
    [breakpoints.up('md')]: {
      maxWidth: 'unset',
    },
  },
  button: {
    width: '100%',
    [breakpoints.up('md')]: {
      width: 'auto',
    },
  },
  veevaContainer: {
    position: 'absolute',
    right: '1%',
    bottom: '1%',
    '&:first-child': {
      fontSize: '0.25rem',
    },
  },
}));
